<template>
  <v-container id="cashout-request-table">
    <v-col class="text-end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="addClick('cashout-request')"
            v-on="on"
            color="white"
            class="primary"
            elevation="1"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("button.new_cashout_request") }}</span>
      </v-tooltip>
    </v-col>
    <MaterialCard
      elevation="0"
      color="primary"
      :title="$t('title.cashout_requests')"
      class="tour-start"
    >
      <base-datatable
        :header_items="headers"
        :type="$t('label.cashout_request')"
        dispatch_get="cashout_requests/cashoutrequests"
        :disable_actions="true"
      ></base-datatable>
    </MaterialCard>
  </v-container>
</template>

<script>
import MaterialCard from "../../../../../components/views/MaterialCard";
import { cashout_request_table } from "@/mixins/cashout_request";
import BaseDatatable from "../../../../../components/views/BaseDatatable";
export default {
  name: "Cashout-Requests",
  components: { BaseDatatable, MaterialCard },
  mixins: [cashout_request_table],
  methods: {
    addClick(route) {
      this.$router.push({
        name: route
      });
    }
  }
};
</script>
